var dropdownMenu = function(){

    var windowWidth = document.body.clientWidth;

    if(windowWidth > 767){

        var navItem = document.getElementsByClassName('dropdown');

        for(var i =0; i< navItem.length; i++){
            navItem[i].onmouseenter = function() { 
                this.classList.add("show")
                this.querySelector(".dropdown-toggle").setAttribute("aria-expanded", "true")
                this.querySelector(".dropdown-menu").classList.add("show")

            }
            navItem[i].onmouseleave = function() { 
                this.classList.remove("show")
                this.querySelector(".dropdown-toggle").setAttribute("aria-expanded", "false")
                this.querySelector('.dropdown-menu').classList.remove("show")
            }
        }

    }

}

// Run on scroll/load/resize
window.addEventListener("scroll", dropdownMenu, false);
window.addEventListener("load", dropdownMenu, false);
window.addEventListener("resize", dropdownMenu, false);